/**
 * Created by BFR on 29/01/2018.
 */
define('orderStatusDetailsController',[
  'module',
  'underscore',
  'app',
  'bootbox',
  'orderStatusDetailsView',
  'emptyView',
  'orderStatusDetailTabController',
  'rolesMixin',
  'settings',
  'orderStatusTabs',
  'entities/caccounts/orderstatus'
], function(
  module,
  _,
  App,
  bootbox,
  View,
  EmptyView,
  orderStatusDetailTabController
) {
  'use strict';

  var OrderStatusDetailsController = {
    fetchOrderStatus: function(data) {
      var that = this,
          emptyView = new EmptyView(),
          contentRegion = App.regions.getRegion('main').currentView.getRegion('content');

      contentRegion.show(emptyView);

      this.data = data;
      if (this.model && this.model.get('secId') === data.secId) {
        this.showOrderStatus(data);
      } else {
        this.model = App.request('orderstatus-tab:new-model', {secId: data.secId});
        this.model.fetch().done(function() {
          if (contentRegion) {
            that.showOrderStatus(data);
          }
        });
      }
    },

      showOrderStatus: function(data) {
      var view = new View({model: this.model, data: data});

      this.view = view;
      data.model = this.model;

      App.regions.getRegion('main').currentView.getRegion('content').show(view);

      this.displayTabs(data);

      view.listenTo(view, 'click:tab', _.bind(this.onTabClick, this));
      view.listenTo(App, 'orderstatus:header:rerender', _.bind(this.onHeaderChange, this));
    },

    onHeaderChange: function (sample) {
      this.view.onHeaderChange(sample);
    },

    displayTabs: function(data) {
      for (var region in this.view.regions) {
        if (App.regions.getRegion('main') && App.regions.getRegion('main').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content') &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region)) {
          var currentViewRegion = App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region).currentView;
          if(currentViewRegion) {
            currentViewRegion.destroy();
          }
        }
      }

      if (data.tab) {
        switch (data.tab.name) {
          default:
              orderStatusDetailTabController.showTab(data);
            break;
        }
      } else {
          orderStatusDetailTabController.showTab(data);
      }

      data.model = this.model;
      this.tab = data.tab;
    },

    onTabClick: function(tab) {
      if (this.data.tab !== tab || this.data.secId) {
        this.data.tab = tab;
        this.data.secId = null;

        this.displayTabs(this.data);
        App.navigate('orderstatus/' + this.model.get('secId') + '/' + tab.name);
      }
    }
  };

  module.exports = OrderStatusDetailsController;
});
